import React from 'react';
import { verticalTimeline } from '../styles/verticalTimeline';
import { useBasicDetails } from '../../store';
import { Icon } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { ReactComponent as Spinner } from '../Images/spinner.svg';

const Timeline = (): JSX.Element => {
  const {
    template: {
      settings: {
        page: { timeline },
      },
    },
    timeLineSpinner,
    timelineStyle,
  } = useBasicDetails();

  const location = useLocation();
  const isGeneralContentPage = location.pathname.includes('general-content');
  const isConsentPage = location.pathname.includes('candidate-consent');
  const classes = verticalTimeline(timeline);

  return (
    <>
      {!(isGeneralContentPage || isConsentPage || timelineStyle) && (
        <div data-testid="timeline" id="JourneyTimeline" className={classes.verticalgrid}></div>
      )}
      {timeLineSpinner ? (
        <Icon data-testid="loaderIcon" className={classes.spinner}>
          <Spinner className={classes.circle} />
        </Icon>
      ) : (
        <></>
      )}
    </>
  );
};

export default Timeline;
